"use strict";

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.define-property");

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var styled_1 = __importDefault(require("@emotion/styled"));

var react_1 = __importDefault(require("react"));

var theme_1 = require("../../styles/theme");

var ContentBlock_1 = __importDefault(require("../primitives/ContentBlock"));

var Card = styled_1["default"](ContentBlock_1["default"])(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", ";\n\n  text-align: ", ";\n  .-icon-container {\n    ", "\n  }\n  .-body-container {\n    ", "\n  }\n  .-copy-container {\n    ", " // Restore left margin if it's a bullet + headline\n  }"], ["\n  ", ";\n\n  text-align: ", ";\n  .-icon-container {\n    ", "\n  }\n  .-body-container {\n    ", "\n  }\n  .-copy-container {\n    ", " // Restore left margin if it's a bullet + headline\n  }"])), function (_a) {
  var bullet = _a.bullet,
      icon = _a.icon;
  return bullet && icon ? "\n    position: relative; /* Allow for absolute positioning of the icon-container */\n  " : "";
}, function (props) {
  return props.align || 'left';
}, function (_a) {
  var bullet = _a.bullet,
      icon = _a.icon;
  return bullet && icon ? "\n      position: absolute;\n      top: 0\n    " : '';
}, function (_a) {
  var bullet = _a.bullet,
      icon = _a.icon;
  return bullet && icon ? "margin-left: " + theme_1.theme.spacing.standard * 2 + "px;" : '';
}, function (_a) {
  var bullet = _a.bullet,
      headline = _a.headline,
      icon = _a.icon;
  return bullet && headline && icon ? "margin-left: " + theme_1.theme.spacing.standard * -2 + "px;" : '';
});

exports["default"] = function (props) {
  return react_1["default"].createElement(Card, __assign({}, props));
};

var templateObject_1;